import React from 'react'
import cn from 'classnames'
import { 
  AppBar, 
  Toolbar
} from '@material-ui/core'
import { useTranslation, Link, useI18next } from 'gatsby-plugin-react-i18next'
import AppIcon from 'assets/svg/app_icon.inline.svg'
import LanguageSelect from 'components/container/nav/LanguageSelect'
import FillButton from 'components/presenter/buttons/FillButton'
import PlatButton from 'components/presenter/buttons/PlatButton'
import * as styles from './header.module.css'

const LandingHeader = () => {
  const { t } = useTranslation()
  const { navigate } = useI18next()

  return (
    <AppBar position="sticky" className={cn(styles.header)}>
      <Toolbar className={styles.toolbar}>
        <AppIcon className={cn(styles.appIcon)} alt={t('seo.description')} onClick={() => navigate('/jetso/')} />
        <div className={styles.space} />
        <PlatButton className={cn('mui-button-link', styles.searchBtn)}>
          <a href={process.env.GATSBY_WENJETO_AUDIENCE} target="_blank">
            {t('landing.jetsoFinder')}
          </a>
        </PlatButton>
        <LanguageSelect className={styles.selectLng}/>
        <FillButton
          className={cn(styles.btnPromote, 'mui-btn-link')}>
          <Link
            to='/jetso/'>
            {t('login.login')}
          </Link>
        </FillButton>
      </Toolbar>
    </AppBar>
  )
}
export default LandingHeader